/** Firestore Timestamp, epoch seconds, or Date */
export const tsToDate = (ts) => {
  if (!ts) return null;
  if (ts instanceof Date) return Number.isNaN(ts.getTime()) ? null : ts;
  if (typeof ts.toDate === 'function') return ts.toDate();
  if (typeof ts.seconds === 'number') return new Date(ts.seconds * 1000);
  return null;
};

/** Day + full month name + year (month translated via langKey). */
export const formatSchoolFacingDate = (value, langKey = 'en') => {
  const d = tsToDate(value);
  if (!d) return '';
  const key = String(langKey || 'en').trim().toLowerCase() || 'en';
  return d.toLocaleDateString(key, { day: 'numeric', month: 'long', year: 'numeric' });
};
